// Each scrolling-features-bar section includes this file, so it can run more than once per page.
if (!window.ScrollingFeaturesBar) {
	window.ScrollingFeaturesBar = class ScrollingFeaturesBar {
		constructor(options = {}) {
			this.options = options;
			this.init();
		}
		init() {
			if (document.readyState === "loading") {
				document.addEventListener("DOMContentLoaded", () => this.setup());
			} else {
				this.setup();
			}
			window.addEventListener("resize", () => this.adjustFeaturesTrack());
			if (document.fonts) {
				document.fonts.ready.then(() => {
					this.setup();
				});
			}
		}
		setup() {
			const allSections = document.querySelectorAll(".scrolling-features-bar[data-section-id]");
			allSections.forEach((section) => {
				if (section.querySelector(".features-track")) {
					this.initSection(section);
				}
			});
		}
		initSection(section) {
			const trackContainer = section.querySelector(".features-track-container");
			const track = section.querySelector(".features-track");
			const featureItems = track.querySelector(".feature-items");
			if (!trackContainer || !track || !featureItems) return;
			this.configureScrollingAnimation(section, track, featureItems);
			this.adjustFeaturesTrack(section, trackContainer, track, featureItems);
		}
		configureScrollingAnimation(section, track, featureItems) {
			const sectionId = section.dataset.sectionId;
			if (!sectionId) return;
			const pauseOnHover = section.classList.contains("pause-on-hover");
			if (pauseOnHover) {
				track.addEventListener("mouseenter", () => {
					track.style.animationPlayState = "paused";
				});
				track.addEventListener("mouseleave", () => {
					track.style.animationPlayState = "running";
				});
			}
		}
		adjustFeaturesTrack(section, trackContainer, track, featureItems) {
			if (!section) {
				const allSections = document.querySelectorAll(".scrolling-features-bar[data-section-id]");
				allSections.forEach((section) => {
					if (section.querySelector(".features-track")) {
						const trackContainer = section.querySelector(".features-track-container");
						const track = section.querySelector(".features-track");
						const featureItems = track.querySelector(".feature-items");
						if (trackContainer && track && featureItems) {
							this.adjustFeaturesTrack(section, trackContainer, track, featureItems);
						}
					}
				});
				return;
			}
			if (!trackContainer || !track || !featureItems) return;
			const featureItemsWidth = featureItems.offsetWidth;
			const totalWidth = featureItemsWidth * 6;
			if (totalWidth > 0) {
				track.style.width = `${totalWidth}px`;
			}
			trackContainer.style.height = `${featureItems.offsetHeight}px`;
		}
	};
	document.addEventListener("DOMContentLoaded", function () {
		new window.ScrollingFeaturesBar();
	});
}
